module.exports = "pegasus/assets/styleGroup3.png";